<template>
  <div>
    <detail :prop="i18n.lbl_sender()" :value="tx.counterparty" :copiable="true"/>
    <detail :prop="i18n.lbl_amount()" :value="`${i18n.c(tx.amount)} ${formatToken}`"/>
    <detail :prop="i18n.lbl_wallet()" v-if="wallet" :value="wallet" :copiable="true"/>
    <detail :prop="i18n.lbl_hash()" v-if="hash" :value="hash" :copiable="true"/>
    <detail :prop="i18n.lbl_internal_hash()" v-if="orderId && internalHash" :value="internalHash" :copiable="true"/>
    <detail :prop="i18n.lbl_order_id()" v-if="orderId" :value="orderId" :copiable="true"/>
    <detail :prop="i18n.lbl_order_amount()" v-if="orderAmount" :value="orderAmount"/>
    <detail :prop="i18n.lbl_order_network()" v-if="orderNetwork" :value="orderNetwork"/>
    <detail :prop="i18n.lbl_fixed_fee()" :value="`${i18n.c(tx.fixedFee)} ${formatToken}`"/>
    <detail :prop="i18n.lbl_percent_fee()" :value="`${i18n.c(tx.percentFee)} ${formatToken}`"/>
    <detail :prop="i18n.lbl_date()" :value="tx.date"/>
    <Aml v-if="tx._record.external_details && tx._record.external_details.aml && aviliableAml" :score="riskScore" :values="amlValues"/>
  </div>
</template>

<script>
  import { subtract } from '@utils/math.util'
  import DetailsMixin from './details.mixin'
  import Aml from './Aml.vue'
  import {CRYPTO_CURRENCYS, AML} from '@utils/consts'
  import CurrencyRound from '@com/mixins/currency.round.mixin'

  export default {
    name: 'issuance-details',
    mixins: [DetailsMixin, CurrencyRound],
    components: { Aml },
    computed: {
      formatToken () {
        return this.tx.asset.startsWith('USDT') ? this.tx.asset.replace(/^USDT/, 'USDT ').replace(/(?<=20)D$/, '') : this.tx.asset
      },
      wallet () {
        if (this.tx._record.external_details) {
          if (this.tx._record.external_details.mainnet_tx_details && this.tx._record.external_details.mainnet_tx_details.wallet !== '') {
            return this.tx._record.external_details.mainnet_tx_details.wallet
          }
          return false
        }
        return false
      },
      hash () {
        if (this.tx._record.external_details) {
          if (this.tx._record.external_details.mainnet_tx_details && this.tx._record.external_details.mainnet_tx_details.tx_hash) {
            return this.tx._record.external_details.mainnet_tx_details.tx_hash
          }
          return false
        }
        return false
      },
      internalHash () {
        if (this.tx._record.external_details) {
          if (this.tx._record.external_details.mainnet_tx_details && this.tx._record.external_details.mainnet_tx_details.transaction_id) {
            return this.tx._record.external_details.mainnet_tx_details.transaction_id
          }
          return false
        }
        return false
      },
      orderId () {
        if (this.tx._record.external_details) {
          if (this.tx._record.external_details.mainnet_tx_details && this.tx._record.external_details.mainnet_tx_details.order_no) {
            return this.tx._record.external_details.mainnet_tx_details.order_no
          }
          return false
        }
        return false
      },
      orderNetwork () {
        if (this.tx._record.external_details) {
          if (this.tx._record.external_details.mainnet_tx_details && this.tx._record.external_details.mainnet_tx_details.order_network) {
            return this.tx._record.external_details.mainnet_tx_details.order_network
          }
          return false
        }
        return false
      },
      orderAmount () {
        if (this.tx._record.external_details) {
          if (this.tx._record.external_details.mainnet_tx_details && this.tx._record.external_details.mainnet_tx_details.order_amount) {
            return `${this.roundCurrency3(this.tx._record.external_details.mainnet_tx_details.order_amount)} 
            ${this.tx._record.external_details.mainnet_tx_details.order_currency ? this.tx._record.external_details.mainnet_tx_details.order_currency : ''}`
          }
          return false
        }
        return false
      },
      aviliableAml () {
        if (Object.values(CRYPTO_CURRENCYS).includes(this.tx.asset) || this.tx.asset.endsWith('20D')) {
          return true
        }
        return false
      },
      totalReceived () {
        return subtract(
          subtract(this.issuance.amount, this.issuance.fixedFee),
          this.issuance.percentFee)
      },
      riskScore () {
        if (this.tx._record.external_details && this.tx._record.external_details.aml) {
          return (this.tx._record.external_details.aml[0] * 100).toFixed(1)
        }
        return null
      },
      amlValues () {
        if (this.tx._record.external_details && this.tx._record.external_details.aml) {
          // eslint-disable-next-line
          let arr = Object.values(this.tx._record.external_details.aml)
          let obj = AML.reduce((acc, key, index) => {
            acc[key] = arr[index]
            return acc
          }, {})
          let {'Risk score': removed, ...others} = obj
          return others
        }
        return null
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/history/index/components/Details.Issuance.vue